import React, { useState, useMemo } from 'react';

import { GeneralPrint, DataKeyType } from '../GeneralPrint';
import { PrintOptionsProps } from './PrintOptions.types';
import { SelectContainer, Select } from './PrintOptions.styles';

const selectData: { Key: DataKeyType; Value: string }[] = [
  {
    Key: 'drawingPrintSettings',
    Value: 'Drawings'
  },
  {
    Key: 'documentPrintSettings',
    Value: 'Documents'
  }
];

export const PrintOptions: React.FC<PrintOptionsProps> = ({
  printProvider,
  printSettings,
  updateManually
}) => {
  const [activeDataKey, setActiveDataKey] = useState<DataKeyType>(
    'drawingPrintSettings'
  );
  const activeIndex = useMemo(
    () => selectData.findIndex(({ Key }) => Key === activeDataKey),
    [activeDataKey]
  );

  return (
    <>
      <SelectContainer>
        <Select
          dropdownData={selectData}
          withSortButton={false}
          activeIndex={activeIndex}
          onClickSelectItem={(idx) => setActiveDataKey(selectData[idx].Key)}
        />
      </SelectContainer>

      <GeneralPrint
        type="printOptions"
        printProvider={printProvider}
        printSettings={printSettings}
        dataKey={activeDataKey}
        updateManually={updateManually}
      />
    </>
  );
};
